import React from "react";
import contextProvider from "../../../contextProvider";
import { withRouter } from "react-router-dom";

import _ReactOBaseComponent from "../../../_L0_components/_ReactOBaseComponent";
import { _LoadingWrapper } from "../../../_L0_components/Widgets/_LoadingKit";

import Panel from "../../../_L1_components/Layout/Panel";
import ReactOTable from "../../../_L1_components/Elements/ReactOTable";
import ReactOModal from "../../../_L1_components/Elements/ReactOModal";
import ReactOActionBar from "../../../_L1_components/Elements/ReactOActionBar";
import ReactOForm from "../../../_L1_components/Elements/ReactOForm";
import ReactOFormInput from "../../../_L1_components/Elements/ReactOFormInput";
import ReactOButton from "../../../_L1_components/Elements/ReactOButton";

class ProbeSetupWifi extends _ReactOBaseComponent {
  constructor(props) {
    var initState = {
      loading: false,
      data: {},
    };
    super(props, initState);
  }

  loadProbeUsers(cb) {
    this.setState(
      {
        loading: true,
      },
      () => {
        if (this.props.onConfLoad) {
          this.props.onConfLoad();
        }
        this.apiStore.fire("get_probe_users", {
          data: {
            probeuid: this.props.match.params.probeuid,
          },
          ___onSuccess: (status, data) => {
            if (this.mounted) {
              this.setState({
                data: {
                  users: data,
                },
                loading: false,
              });
            }
          },
        });
      }
    );
  }

  saveProbeUsers(data, cb) {
    this.setState(
      {
        loading: true,
      },
      () => {
        this.apiStore.fire("set_probe_users_with_filter", {
          data: {
            probeuid: this.props.match.params.probeuid,
            userid: data.id.toString(),
            value: {
              username: data.username,
              pwd: data.pwd,
              type: data.type,
            },
          },
          ___onSuccess: (status, data) => {
            this.setState(
              {
                loading: false,
              },
              () => {
                this.loadProbeUsers();
                if (cb) {
                  cb(status, data);
                }
              }
            );
          },
        });
      }
    );
  }

  createProbeUser(data, cb) {
    this.setState(
      {
        loading: true,
      },
      () => {
        this.apiStore.fire("create_probe_user", {
          data: {
            probeuid: this.props.match.params.probeuid,
            value: {
              username: data.username,
              pwd: data.pwd,
              type: data.type,
            },
          },
          ___onSuccess: (status, data) => {
            this.setState(
              {
                loading: false,
              },
              () => {
                this.loadProbeUsers();
                if (cb) {
                  cb(status, data);
                }
              }
            );
          },
        });
      }
    );
  }

  deleteProbeUser(data, cb) {
    this.setState(
      {
        loading: true,
      },
      () => {
        this.apiStore.fire("delete_probe_user", {
          data: {
            probeuid: this.props.match.params.probeuid,
            userid: data.id.toString(),
          },
          ___onSuccess: (status, data) => {
            this.setState(
              {
                loading: false,
              },
              () => {
                this.loadProbeUsers();
                if (cb) {
                  cb(status, data);
                }
              }
            );
          },
        });
      }
    );
  }

  /////////////////////////
  //	Lifecycle methods
  //

  onComponentDidMount() {
    this.mounted = true;
    this.apiStore = this.getAppContext().getApiStoreService();
    this.loadProbeUsers();
  }

  onComponentWillUnmount() {
    this.mounted = false;
  }

  onRender() {
    return (
      <_LoadingWrapper loadingPlug={this.state.loading}>
        <Panel
          className="mb-4 rounded-bottom"
          //	header="WiFi"
          style={{
            minHeight: "50px",
          }}
        >
          <ReactOActionBar align="right" padding="0" className="mb-3">
            <ReactOButton
              icon="plus-circle"
              color="primary"
              onClick={() => {
                this._user_editing_modal.open({ _is_new: true });
              }}
            >
              Add user
            </ReactOButton>
          </ReactOActionBar>

          <ReactOTable
            size="sm"
            cols={[
              {
                title: "Username",
                data_key: "username",
                sortable: true,
              },
              {
                title: "Type",
                data_key: "type",
                sortable: true,
              },
              {
                title: "",
                data_key: "ctrl",
                align: "right",
              },
            ]}
            rows={(() => {
              let _TMP = [];
              (this.state.data.users ? this.state.data.users : []).forEach(
                (_CURR_user, _CURR_idx) => {
                  _TMP.push({
                    ..._CURR_user,
                    ctrl: (
                      <ReactOActionBar align="right" padding="0">
                        <ReactOButton
                          icon="pencil"
                          size="sm"
                          onClick={() => {
                            this._user_editing_modal.open(_CURR_user);
                          }}
                        >
                          Edit
                        </ReactOButton>
                        <ReactOButton
                          icon="delete"
                          color="danger"
                          size="sm"
                          onClick={() => {
                            this._user_deleting_modal.open(_CURR_user);
                          }}
                        ></ReactOButton>
                      </ReactOActionBar>
                    ),
                  });
                }
              );
              return _TMP;
            })()}
          />

          <ReactOModal
            modalId="userEditing"
            size="md"
            loading={this.state.loading}
            onControllerReady={(modal_context) => {
              this._user_editing_modal = modal_context;
            }}
            onModalMounted={(data) => {
              this._user_editing_form.init({
                ...(data._is_new ? {} : { id: data.id }),
                username: data.username,
                pwd: data.pwd,
                type: data.type,
              });
            }}
            header={(data) => {
              return data._is_new ? "Create new user" : "Edit user";
            }}
            body={(data) => {
              return (
                <ReactOForm
                  onSubmit={
                    data._is_new
                      ? this.createProbeUser.bind(this)
                      : this.saveProbeUsers.bind(this)
                  }
                  unsavedWarning={true}
                  onControllerReady={(form_controller) => {
                    this._user_editing_form = form_controller;
                  }}
                >
                  <ReactOFormInput
                    className="mb-3"
                    type="text"
                    data_key="username"
                    placeholder="Username"
                    autofocus
                    size="md"
                    default=""
                    validators={[
                      {
                        func: (value) => {
                          return /^.+$/.test(value);
                        },
                        invalid_text: "Type a username",
                      },
                    ]}
                  />
                  <ReactOFormInput
                    className="mb-3"
                    type="password"
                    data_key="pwd"
                    placeholder="Password"
                    size="md"
                    default=""
                    validators={[
                      {
                        func: (value) => {
                          return /^.+$/.test(value);
                        },
                        invalid_text: "Type a valid password",
                      },
                    ]}
                  />
                  <ReactOFormInput
                    type="select"
                    data_key="type"
                    size="md"
                    default="USER"
                    options={[
                      { name: "User", value: "USER" },
                      { name: "Admin", value: "ADMIN" },
                    ]}
                    validators={[
                      {
                        func: (value) => {
                          return /^.+$/.test(value);
                        },
                        invalid_text: "Type a username",
                      },
                    ]}
                  />
                </ReactOForm>
              );
            }}
            actions={[
              {
                text: "Cancel",
                color: "light",
                action: "close",
              },
              (data) => {
                return {
                  text: data._is_new ? "Create" : "Save",
                  color: "primary",
                  icon: "save",
                  action: () => {
                    this._user_editing_form.submit((submit_result) => {
                      if (submit_result.status === true) {
                        this._user_editing_modal.close();
                      }
                    });
                  },
                };
              },
            ]}
          />

          <div className="sub-title mt-1">
            <p>
              The users defined in this section are local to the probe device and not
              synched to the cloud.
              <br />
              Using these credentials you can log in directly to the web user interface on
              the probe via:
              <br />
              <span style={{ paddingLeft: "1em" }}>- the USB cable</span>
              <br />
              <span style={{ paddingLeft: "1em" }}>
                - the IP address assigned to the RJ45 ethernet interfaces if this is not
                used to carry ethernet measures.{" "}
              </span>
            </p>
          </div>

          <ReactOModal
            modalId="userDeleting"
            size="md"
            loading={this.state.loading}
            onControllerReady={(modal_context) => {
              this._user_deleting_modal = modal_context;
            }}
            onModalMounted={(data) => {}}
            header="Delete user"
            body={(data) => {
              return (
                <span>
                  Delete user <strong>{data.username}</strong>?
                </span>
              );
            }}
            actions={[
              {
                text: "Cancel",
                color: "light",
                action: "close",
              },
              (data) => {
                return {
                  text: "Delete",
                  color: "danger",
                  icon: "delete",
                  action: () => {
                    this.deleteProbeUser(data, (submit_status, submit_data) => {
                      if (submit_status == "OK") {
                        this._user_deleting_modal.close();
                      }
                    });
                  },
                };
              },
            ]}
          />
        </Panel>
      </_LoadingWrapper>
    );
  }
}

export default contextProvider(
  withRouter(ProbeSetupWifi),
  //	withDefinedContext(ProbeSetupWifi, 'ProbeSetupWifi', context_exposed_methods),
  {
    define: null,
  }
);
